<template>
  <div style="padding: 15px 10px;">
    <el-row class="line button">
      <!--      <el-button @click="() => openDialog({})" icon="el-icon-circle-plus-outline" type="primary">新增策略</el-button>-->
      <el-button icon="el-icon-circle-plus-outline"
                 size="small" @touchstart="openDialog({})" @click="openDialog({})">
        新增策略
      </el-button>
      <span style="margin-left: 20px;">
        空间：<el-cascader
        :options="spaceTree"
        @change="changeSpace"
        change-on-select="true"
        clearable
        collapse-tags
        filterable
        placeholder="请选择"
        size="mini"
        style="padding-bottom: 5px; width: calc(100%/4 - 120px)"
        v-model="spaceId">
        </el-cascader>
      </span>
      <span style="margin-left: 20px;">
        告警等级：<el-select
        clearable
        filterable
        collapse-tags
        placeholder="请选择"
        @change="getPageList"
        size="mini"
        style="padding-bottom: 5px;width: calc(100%/4 - 120px)"
        v-model="levelId">
                  <el-option
                    :key="item.id"
                    :label="item.levelName"
                    :style="{color: item.levelColor}"
                    :value="item.id"
                    v-for="item in levelList">
                  </el-option>
                </el-select>
      </span>
      <span style="margin-left: 20px;">
        通知人：<el-select
        placeholder="请选择"
        @change="getPageList"
        size="mini"
        clearable
        filterable
        style="padding-bottom: 5px;width: calc(100%/4 - 120px)"
        v-model="account">
                  <el-option
                    :key="item.id"
                    :label="item.nickname"
                    :value="item.id"
                    v-for="item in accountList">
                  </el-option>
                </el-select>
      </span>
      <span style="margin-left: 20px;">
        通知方式：<el-select
        @change="getPageList"
        placeholder="请选择"
        size="mini"
        clearable
        filterable
        style="padding-bottom: 5px;width: calc(100%/4 - 120px)"
        v-model="notify">
                  <el-option
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                    v-for="item in notifyList">
                  </el-option>
                </el-select>
      </span>
    </el-row>
    <el-table
      :data="tableData"
      border
      class="table"
      style="width: 100%;margin-top: 10px;">
      <el-table-column
        align="center"
        label="空间"
        prop="spaceName">
      </el-table-column>
      <el-table-column
        align="center"
        label="告警等级"
        prop="levelName">
        <template slot-scope="scope">
          <span :style="{color: scope.row.levelColor }">{{ scope.row.levelName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="通知人"
        prop="accountName">
      </el-table-column>
      <el-table-column
        align="center"
        label="通知方式"
        prop="typeName">
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div @touchstart="openDialog(scope.row)" @click="() => openDialog(scope.row)" class="text-center control edit d-inline-block mr-1">
            <img alt="编辑" class="d-inline-block" src="@/assets/images/icon/edit.png">
            编辑
          </div>
          <div @touchstart="remove(scope.row)" @click="remove(scope.row)" class="text-center control delete d-inline-block ml-1">
            <img alt="删除" src="@/assets/images/icon/delete.png">
            删除
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="margin-top: 15px;text-align: center;" v-if="tableData.length > 0">
      <el-pagination
        :current-page.sync="current"
        :page-size.sync="size"
        :total="dataTotal"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next">
      </el-pagination>
    </el-row>


    <function-dialog-component
      :dialog-title="title"
      :dialogVisible.sync="deviceDialogVisible"
      @dialogClose="(data) => this.deviceDialogVisible = data"
      center
      width="40vw">
      <div slot="content"
           style="padding: 10px 30px 20px 40px;height: 50vh">

        <el-col :lg="9" :md="7" :sm="8" :xl="8" :xs="24"
                class="overflow" style="padding: 10px 0 0 30px;height: 100%;overflow: auto;">
          <space-tree-show :space-id="editRow.spaceId ? editRow.spaceId : null"
                           @spaceChoose="spaceChoose" class="space" ref="space"/>
        </el-col>
        <el-col :lg="15" :md="17" :sm="16" :xl="16" :xs="24" style="height: 100%;padding-top: 40px;">
          <div v-if="hasPermission">
            <el-row>
              <el-col :lg="8" :md="8" :sm="8" :xl="7" :xs="8"
                      style="line-height: 28px;text-align: right;margin-right: 20px;">告警等级：
              </el-col>
              <el-col :lg="14" :md="14" :sm="14" :xl="15" :xs="14">
                <el-select
                  collapse-tags
                  placeholder="请选择"
                  size="mini"
                  style="padding-bottom: 5px;width: 80%;"
                  v-model="levelId">
                  <el-option
                    :key="item.id"
                    :label="item.levelName"
                    :style="{color: item.levelColor}"
                    :value="item.id"
                    v-for="item in levelList">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
              <el-col :lg="8" :md="8" :sm="8" :xl="7" :xs="8"
                      style="line-height: 28px;text-align: right;margin-right: 20px;">通知人：
              </el-col>
              <el-col :lg="14" :md="14" :sm="14" :xl="15" :xs="14">
                <el-select
                  :multiple="!edit"
                  placeholder="请选择"
                  size="mini"
                  style="padding-bottom: 5px;width: 80%;"
                  v-model="account">
                  <el-option
                    :key="item.id"
                    :label="item.nickname"
                    :value="item.id"
                    v-for="item in accountList">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
              <el-col :lg="8" :md="8" :sm="8" :xl="7" :xs="8"
                      style="line-height: 28px;text-align: right;margin-right: 20px;">通知方式：
              </el-col>
              <el-col :lg="14" :md="14" :sm="14" :xl="15" :xs="14">
                <el-select
                  @change="changeNotifyType"
                  :multiple="!edit"
                  placeholder="请选择"
                  size="mini"
                  style="padding-bottom: 5px;width: 80%;"
                  v-model="notify">
                  <el-option
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                    v-for="item in notifyList">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <div v-else>
            暂无空间权限
          </div>
        </el-col>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;">
        <el-button @touchstart="() => {this.deviceDialogVisible = false;this.editRow = {};this.init()}" @click="() => {this.deviceDialogVisible = false;this.editRow = {};this.init()}" size="mini">关 闭</el-button>
        <el-button @touchstart="commit" @click="commit" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import {deleteById, getAccountListBySpaceId, getPageList, saveReceiver, updateReceiver} from "@/network/alarm-receiver";
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import SpaceTreeShow from "@/components/space/SpaceTreeShow";
import {getLevelList} from "@/network/alarm-level";
import {getSystematicByParentCodes} from "@/network/systematic";
import {getSpaceTreeData, getTreeHaveDisabled} from "@/network/space-info";

export default {
  name: "NoticeReceiver",
  components: {FunctionDialogComponent, SpaceTreeShow},
  inject: ['overflow'],
  data() {
    return {
      spaceTree: [{
        value: '',
        label: ''
      }],
      tableData: [],
      current: 1,
      size: 10,
      dataTotal: 0,
      title: "新增策略",
      deviceDialogVisible: false,
      // 首次进入
      isLoad: true,
      spaceId: null,
      spaceName: null,
      levelId: '',
      account: [],
      notify: [],
      notifyName: [],
      editRow: {},
      levelList: [],
      accountList: [],
      notifyList: [],
      hasPermission: false,
      edit: false,
    }
  },
  mounted() {
    this.overflow();
    this.init();
  },
  methods: {
    init() {
      this.spaceId=''
      this.levelId=null
      this.account=[]
      this.notify=[]
      this.getSpaceTreeData();
      this.getPageList();
      this.getLevelList();
      this.getByParentCodes();
      // this.spaceId = null;
      // this.spaceName = null;
      this.editRow = {};
    },
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          this.spaceTree = getTreeHaveDisabled(res.data);
        }
      });
    },
    //分页获取列表数据
    getPageList() {
      getPageList(this.current, this.size, this.spaceId, this.levelId,this.account,this.notify).then(res => {
        this.tableData = res.data.records;
        this.dataTotal = res.data.total;
      })
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getPageList();
    },
    openDialog(row) {
      if (row.id) {
        this.title = "编辑策略"
        this.edit = true;
        this.editRow = row
        this.levelId = row.levelId
        this.account = row.accountId
        this.notify = row.typeCode
        this.notifyName = row.typeName
      } else {
        this.title = "新增策略"
        this.edit = false;
        this.editRow = {}
        this.levelId = ''
        this.notify = []
        this.account = []
        this.notifyName = []
      }
      this.deviceDialogVisible = true;
    },
    changeSpace() {
      this.current = 1;
      this.getAccountListBySpaceId();
      this.getPageList();
    },
    //空间选择 逻辑空间无法选择
    spaceChoose(spaceInfo) {
      console.log(spaceInfo, "--------");
      if (this.isLoad === true) {
        this.isLoad = false;
        // if (this.editRow.spaceId) {
        //   const firstTree = this.$refs.space.selectedSpace(this.editRow.spaceId, null);
        //   this.$refs.space.ztreeObj.selectNode(firstTree);
        // }
        this.spaceId = spaceInfo.id;
        this.spaceName = spaceInfo.title;
        this.getAccountListBySpaceId();
      } else {
        if (spaceInfo.type !== 1) {
          this.spaceId = spaceInfo.id;
          this.spaceName = spaceInfo.title;
          this.getAccountListBySpaceId();
        } else {
          this.$message.error('此空间为逻辑空间,无法选择');
          this.spaceId = null;
          this.spaceName = null;
          this.$refs.space.ztreeObj.selectNode([]);
        }
      }
    },
    //获取告警等级
    getLevelList() {
      this.levelList = []
      getLevelList().then(res => {
        this.levelList = res.data;
      })
    },
    //判断该空间是否有权限,获取接收人列表
    getAccountListBySpaceId() {
      this.accountList = [];
      getAccountListBySpaceId(this.spaceId).then(res => {
        this.hasPermission = false;
        if (res.code === 0) {
          this.accountList = res.data.accounts;
          if (res.data.permission.length > 0) {
            this.hasPermission = true;
          }
          if (this.accountList.length < 1) {
            this.account = ''
          }
        }
      })
    },
    //获取通知方式
    getByParentCodes() {
      this.notifyList = []
      getSystematicByParentCodes("notification_type").then(res => {
        this.notifyList = res.data;
      })
    },
    //通知方式下拉框选择
    changeNotifyType(codes) {
      if (typeof codes === 'string') {
        this.notifyName = this.notifyList.filter(i => i.code === codes)[0].name
      } else {
        this.notifyName = []
        codes.forEach(code => {
          const item = this.notifyList.filter(i => i.code === code)[0]
          this.notifyName.push(item.name)
        })
      }
    },
    //新增或保存 确认按钮事件
    commit() {
      if (this.levelId) {
        if (this.account.length) {
          if (this.notify.length) {
            this.editRow.levelId = this.levelId;
            this.editRow.spaceId = this.spaceId;
            //修改
            if (typeof this.notify === 'string') {
              this.editRow.accountId = this.account;
              this.editRow.typeCode = this.notify;
              this.editRow.typeName = this.notifyName;
              this.updateReceiver();
            } else {
              //新增
              this.editRow.notifierIdList = this.account;
              this.editRow.notificationTypeCodeList = this.notify;
              this.editRow.notificationTypeNameList = this.notifyName;
              this.saveReceiver();
            }
          } else {
            this.$message.error("请选择通知方式!")
          }
        } else {
          this.$message.error("请选择通知人!")
        }
      } else {
        this.$message.error("请选择告警等级!")
      }

    },
    saveReceiver() {
      saveReceiver(this.editRow).then(res => {
        if (res.code === 0) {
          this.$message.success("新增成功!")
        } else {
          this.$message.error("新增失败!")
        }
        this.init();
        this.deviceDialogVisible = false;
      })
    },
    updateReceiver() {
      updateReceiver(this.editRow).then(res => {
        if (res.code === 0) {
          this.$message.success("编辑成功!")
        } else {
          this.$message.error("编辑失败!")
        }
        this.init();
        this.deviceDialogVisible = false;
      })
    },
    //删除事件
    remove(row) {
      this.$confirm('是否确认删除策略', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            deleteById(row.id).then(res => {
              if (res.code === 0) {
                this.$message.success("删除成功!");
              } else {
                this.$message.error("删除失败!")
              }
              this.init();
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

.control img {
  margin-top: -5px;
}

.control.edit:hover {
  cursor: pointer;
  color: #299FFB;
}

.control.delete:hover {
  cursor: pointer;
  color: #fb2929;
}
</style>
